import TrenderQuatationslistCompare from "@/app/features/tender/components/view/tender-list-compare";
import React from "react";

const QuatationTendersPage: React.FC = () => {
  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#f8fafa !important" }}
    >
      <div className="container mx-auto p-6">
        <TrenderQuatationslistCompare />
      </div>
    </div>
  );
};

export default QuatationTendersPage;
